import React, { useState } from 'react';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { Input, PrimaryButton, SecondaryButton } from "../UI";
import { createOrgLevel } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const AddOrgLevelModal = ({ hideModal, onSuccess, copyFrom = null }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();
    const [level, setLevel] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!level || isNaN(level)) {
            setError(content.ORGLEVELS.add_modal.error_valid_number || 'Please enter a valid number.');
            return;
        }

        try {
            setLoading(true);
            setError('');
            const payload = {
                id: level,
                copyFrom: copyFrom ? copyFrom.id : null
            };
            await createOrgLevel(userData?.token, userData?.selectedOrganization?.org_token, payload);
            onSuccess();
            hideModal(false);
        } catch (err) {
            setError(err.error || err.message || content.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PrimaryModal
            title={copyFrom ? `${content.ORGLEVELS.add_modal.title_copy || 'Copy Org Level'} (${copyFrom.id})` : (content.ORGLEVELS.add_modal.title_add || 'Add Org Level')}
            hideModal={hideModal}
        >
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
                <Input
                    label={content.ORGLEVELS.add_modal.label_level || 'Org Level ID (e.g., 1, 2, 3...)'}
                    type="number"
                    id="level"
                    placeholder="Enter level number"
                    value={level}
                    onChange={(e) => setLevel(e.target.value)}
                    mandatory
                />
                {error && <p className="text-red-500 text-sm">{error}</p>}
                <div className="flex justify-end gap-3 pt-4 border-t">
                    <SecondaryButton handleClick={() => hideModal(false)}>
                        {content.ORGLEVELS.add_modal.cancel_cta}
                    </SecondaryButton>
                    <PrimaryButton type="submit" loading={loading} disabled={loading}>
                        {content.ORGLEVELS.add_modal.submit_cta}
                    </PrimaryButton>
                </div>
            </form>
        </PrimaryModal>
    );
};

export default AddOrgLevelModal;
